import React from "react";
import Icondigital from "../../icons/icon-digital.svg";
import Imagedigital from "../../images/icon-digital.svg";
import IconDataAnalytics from "../../icons/icon-data-analytics.svg";
import ImageDataAnalytics from "../../images/icon-data-analytics.svg";
import IconApple from "../../icons/icon-apple.svg";
import IconAndroid from "../../icons/icon-android.svg";
import IconCrossPlatform from "../../icons/icon-cross-platform.svg";
import IconEnterprise from "../../icons/icon-enterprise.svg";
import IconMobileWallet from "../../icons/icon-mobile-wallets.svg";
import IconApiReset from "../../icons/icon-api-reset.svg";
import IconWearables from "../../icons/icon-wearables.svg";
import IconIotApp from "../../icons/icon-iot-app.svg";
import PageBannerImage from "../../images/page-banner-mobile-development.png";
import PageBannerVideo from "../../images/mobile-banner-video.mp4";
import ProductBannerImage from "../../images/page-banner-product-mobile-development.png";
import IconMobile from "../../icons/icon-mobile.svg";
import IconEngagement from "../../icons/icon-engagement.svg";
import IconOmnichannel from "../../icons/icon-omnichannel.svg";
import IconStrategy from "../../icons/icon-strategy.svg";
import IconDesign from "../../icons/icon-design.svg";
import IconEngineering from "../../icons/icon-engineering.svg";
import IconTesting from "../../icons/icon-testing.svg";
import IconDelivery from "../../icons/icon-delivery.svg";
import IconMaintenance from "../../icons/icon-maintenance.svg";
import IconTechApple from "../../icons/icon-ios.svg";
import IconTechAndroid from "../../icons/icon-android-tech.svg";
import IconTechReact from "../../icons/icon-react.svg";
import IconTechFlutter from "../../icons/icon-flutter-app.svg";
import IconJavaScript from "../../icons/icon-javascript.svg";
import IconFlutter from "../../icons/icon-flutter.svg";
import IconGraphQl from "../../icons/icon-graph-ql.svg";
import IconUnitTest from "../../icons/icon-unit-testing.svg";
import IconSwift from "../../icons/icon-swift.svg";
import IconKotlin from "../../icons/icon-kotlin.svg";
import IconResponsive from "../../icons/icon-responsive.svg";
import IconCicd from "../../icons/icon-cicd.svg";
import IconGit from "../../icons/icon-git.svg";
import IconAws from "../../icons/icon-aws.svg";
import IconMl from "../../icons/icon-ml.svg";
import IconIot from "../../icons/icon-iot.svg";
import ImageUser from "../../images/img-user.jpeg";
import ImageUserSmair from "../../images/profile-samir.jpg";
import ImageUserJohn from "../../images/profile-john.jpg";
import ImageUserJustin from "../../images/justin-profile.jpg";
import IconSalesmate from "../../images/icon-salesmate.svg";
import IconPhysioOutcome from "../../images/icon-physiooutcome.svg";
import IconYodish from "../../images/icon-yodish.png";
import { Link } from "gatsby";
import IconBuildDemand from "../../icons/icon-build-new-on-demand.svg";
import IconAttractGen from "../../icons/icon-attract-next-gen.svg";
import IconIncreaseEfficiencies from "../../icons/icon-increase-efficiencies-m.svg";
import Android from '../../icons/svg_animations/Android/Android-2.json';
import CrossPlatform from '../../icons/svg_animations/Cross-platform Apps/Cross-platform Apps-2.json';
import Enterprise from '../../icons/svg_animations/Enterprise/Enterpris-2.json';
import IotApps from '../../icons/svg_animations/IoT Apps/IoT Apps-2.json';
import RestAPI from '../../icons/svg_animations/REST API/REST API-2.json';
import Wearables from '../../icons/svg_animations/Wearables/Wearables-2.json';
import Wallets from '../../icons/svg_animations/Mobile Wallets/Mobile Wallets-2.json';
import IOS from '../../icons/svg_animations/iOS Apps/iOS Apps-2.json';

import ImageKroger from "../../images/services-cs-kroger.png";
import ImageCBHalf from "../../images/service-cs-cb-half.jpg";
import ImagePODHalf from "../../images/services-cs-pod-half.jpg";

import IconBusinessOpportunity from "../../icons/icon-business-opportunity1.svg";
import IconCustomerNeeds from "../../icons/icon-customerneeds.svg";
import IconMarketResearch from "../../icons/icon-market-research.svg";
import IconProductExperience from "../../icons/icon-product-experience.svg";


export const blockQuoteObj = {
  classes: "md-blockquote",
  quote: "I have brought Rapidops in for massive digital transformation projects at my last three companies (all different industries) and will continue to do so. I am impressed with the exceptional quality, expertise, and speed they brought to the table.",
  author: "Chase Cabanillas",
  occupation: "CIO, Flexprint",
};
export const columnLayoutObj = {
  classes: "",
  header: "Checkout our other services",
  subHeader: (<></>),
  services: [
    {
      icon: <Icondigital />,
      image: Imagedigital,
      alt: "web application development company",
      title: "Product Design",
      header: "Product Design",
      content: "Craft state-of-the-art digital experiences for your next digital product.",
      link: "/services/digital-product/"
    }, {
      icon: <IconDataAnalytics />,
      image: ImageDataAnalytics,
      alt: "data analytics services",
      title: "Data Analytics",
      header: "Data Analytics",
      content: "Grow your business with actionable intelligence and data-driven products.",
      link: "/services/data-analytics/"
    }
  ]
};
export const gridlayoutObj = {
  classes: "three-row-three-col-grid",
  header: "our mobile development expertise",
  subHeader: (<>Building engaging mobile experiences on all devices for all industries</>),
  gridItems: [
    {
      icon: <IconApple />,
      header: "iOS Apps",
      svgIcon: IOS,
      content: "Build tailor-made native apps for iPhone and iPad that are secure, flawless and meticulously designed."
    },
    {
      icon: <IconAndroid />,
      svgIcon: Android,
      altText: "icon android",
      header: "Android Apps",
      content: "Design and develop smartphone and tablet apps for the world’s largest mobile operating system."
    },
    {
      icon: <IconCrossPlatform />,
      svgIcon: CrossPlatform,
      header: "Cross-platform Apps",
      content: "Create one powerful app to rule both mobile platforms - iOS and Android. It saves time, effort and money."
    },
    {
      icon: <IconMobileWallet />,
      svgIcon: Wallets,
      header: "Mobile Wallets & Payment",
      content: "Launch apps that can take orders, process payments, offer rewards, and automate business transactions."
    },
    {
      icon: <IconApiReset />,
      svgIcon: RestAPI,
      header: "REST API Backends",
      content: "Build robust, secure, and scalable API platforms that orchestrate existing services and powers all customer-facing apps."
    },
    {
      icon: <IconEnterprise />,
      svgIcon: Enterprise,
      header: "Enterprise Mobile Solutions",
      content: "Launch internal and customer-facing mobile apps that securely digitize existing enterprise services with stunning user experience."
    },
    {
      icon: <IconWearables />,
      svgIcon: Wearables,
      header: "Wearable Apps",
      content: "With 500 million+ wearable devices and counting, launch innovative apps (e.g., health and payments) for Apple and Android devices."
    },
    {
      icon: <IconIotApp />,
      svgIcon: IotApps,
      header: "IoT Apps",
      content: "Launch apps that allow operating devices for automating the manual process in any industry or creating unique customer experiences."
    }
  ]
};
export const introColumnObj = {
  classes: "service-inner-intro",
  header: "our mobile development expertise",
  subHeader: "Top-notch software engineering that takes mobile products for zero to one (and beyond) in less than 4 weeks",
  intro: (<><p>We deeply care about the quality, simplicity, and success of every mobile product we ship. Within past 12 years of experience, we have developed wide range of mobile technologies and best practices that encompass clean architecture practices, native hardware integrations, data management, and integration with various devices and third-party services to offer unique, personalized and productive user experiences. </p>
    <p>Leverage the most innovative technologies that allow you to ship pristine, reliable, and maintainable mobile apps that create ROI in weeks, and scale to support growth. </p></>),
};
export const mainBannerObj = {
  classes: "",
  title: "",
  header: (<>Mobile App  <br />Development</>),
  content: "Launch mobile products and on-demand experiences that create new growth opportunities and increase loyalty.",
  mediaClass: "align-end justify-center",
  mediaType: "video",
  mediaSource: PageBannerVideo
};
export const pageIntroObj = {
  classes: "",
  title: "Monetize your mobile app",
  header: "The Most Impressive Opportunity for Profit and Growth",
  content: (<><p>With over 5 billion mobile devices worldwide, mobile is becoming the preferred channel for all digital interactions. The mobile apps have the power to offer customers exactly what they want, where they want, and for as long as they want.</p>
    <p>Since 2008, we have partnered with multiple startups and enterprises across the world to launch award-winning mobile applications. Our apps touch hundreds of millions of users and have created multi-million dollar revenue channels for our customers and counting. </p></>)
};
export const featureColunObj = {
  classes: "",
  title: "key ingredients",
  header: "Building a Successful Mobile App",
  items: [{
    header: (<>Business <br />Opportunity</>),
    content: "Create tangible and measurable ROI for the business",
    icon: <IconBusinessOpportunity />,
  }, {
    header: (<>Customer <br />Needs</>),
    content: "Offer unique value by solving for the customer",
    icon: <IconCustomerNeeds />,
  }, {
    header: (<>Market <br />Research</>),
    content: "Understand the trends, traction and competition",
    icon: <IconMarketResearch />,
  }, {
    header: (<>Product <br />Experience</>),
    content: "Craft flawless and intuitive on-demand experiences",
    icon: <IconProductExperience />,
  },
  ]
};

export const productDetailBannerObj = {
  classes: "",
  title: "Harris Teeter",
  header: (<>Transforming online shopping <br />for millions of customers</>),
  subHeader: "How we helped one of the largest grocery chain in south-east US build a multi million dollar mobile revenue channel.",
  items: [
    {
      count: "5",
      countContent: " Billion+",
      content: "Revenue"
    },
    {
      count: "400",
      countContent: "+",
      content: "Stores"
    }
  ],
  image: ProductBannerImage,
  classes: ""
};

export const threeColSliderObj = {
  classes: "opportunity",
  header: <>Monetize your mobile opportunity</>,
  subHeader: "Our custom mobile app development services",
  items: [
    {
      icon: <IconMobile />,
      header: "Grow Existing Business on Mobile",
      content: "Grow revenue for existing business products and services by offering them to XX billion mobile users."
    }, {
      icon: <IconOmnichannel />,
      header: "Deliver Omnichannel Experiences",
      content: "Offer your customers seamless & personalized services across web, email, store, and mobile channels."
    }, {
      icon: <IconEngagement />,
      header: "Increase Customer Engagement",
      content: "Create in-the-moment experiences for each customer using personalized content, notifications & analytics."
    }, {
      icon: <IconBuildDemand />,
      header: "Build New On-demand MVP",
      content: "Turn your innovative idea into the next big delivery, payments, shopping, or social app."
    }, {
      icon: <IconAttractGen />,
      header: "Attract Next-generation Customers",
      content: "Lead the industry with mobile-first services that attract next-generation of mobile-savvy customers."
    }, {
      icon: <IconIncreaseEfficiencies />,
      header: "Increase Efficiencies with Mobile",
      content: "Automate manual business processes by building contextual IoT and operational apps."
    }
  ]
};

export const processFlowObj = {
  classes: "",
  title: "agile software development",
  header: "Proven and battle-tested process",
  subHeader: "With 11 years and 200+ products, we’ve battle-tested our approach to products, people, and processes. From vision to strategy to a roadmap to delivery and beyond, we go end-to-end; no other vendor needed to fill the gaps. We stay lean, move fast, and deliver tangible products in weeks (not the $50,000 PPT or vaporware).",
  items: [
    {
      class: "process-item border-bottom",
      icon: <IconStrategy />,
      name: "Strategy"
    },
    {
      class: "process-item border-right",
      icon: <IconDesign />,
      name: "Design"
    },
    {
      class: "process-item border-right border-bottom",
      icon: <IconEngineering />,
      name: "Engineering"
    },
    {
      class: "process-item",
      icon: <IconTesting />,
      name: "Testing"
    },
    {
      class: "process-item border-right border-top-right-radius",
      icon: <IconDelivery />,
      name: "Delivery"
    },
    {
      class: "process-item",
      icon: <IconMaintenance />,
      name: "Maintenance"
    }
  ]
};

export const techColumnObj = {
  classes: "md-grid-layout technology-md",
  items: [
    {
      icon: <IconTechApple />,
      header: "iOS App Development",
      content: "Amplify on the power of Swift and Objective C to build a super-rich user experience for iOS devices. "
    }, {
      icon: <IconTechAndroid />,
      header: "Android App Development",
      content: "Leave no stone unturned, create android apps that are designed to reach its massive user base."
    }, {
      icon: <IconTechReact />,
      header: "React Native App Development",
      content: "Get a super intuitive app for all device types. Our React Native expertise that can beat native in its own game."
    }, {
      icon: <IconTechFlutter />,
      header: "Flutter App Development",
      content: "Accelerate your product value by developing robust and native-like experiences from a single codebase."
    },
  ]
};

export const techSliderObj = {
  classes: "md-technology",
  items: [
    {
      link: "/",
      image: <IconJavaScript />,
      name: "Javascript"
    }, {
      link: "/",
      image: <IconFlutter />,
      name: "Flutter"
    }, {
      link: "/",
      image: <IconGraphQl />,
      name: "GraphQL"
    }, {
      link: "/",
      image: <IconUnitTest />,
      name: "Unit Testing"
    }, {
      link: "/",
      image: <IconSwift />,
      name: "Swift"
    }, {
      link: "/",
      image: <IconKotlin />,
      name: "Kotlin"
    }, {
      link: "/",
      image: <IconResponsive />,
      name: "Responsive"
    }, {
      link: "/",
      image: <IconCicd />,
      name: "CI/CD"
    }, {
      link: "/",
      image: <IconGit />,
      name: "Git"
    }, {
      link: "/",
      image: <IconAws />,
      name: "AWS"
    }, {
      link: "/",
      image: <IconMl />,
      name: "AI/ML"
    }, {
      link: "/",
      image: <IconIot />,
      name: "IoT"
    }
  ]
};

export const testimonialSliderObj = {
  classes: "",
  title: <>We've shipped award-winning mobile apps for our clients</>,
  header: "See how we lived before existing customers.",
  link: "/",
  items: [
    {
      content: "Rapidops have enabled our patients to receive their care and stay connected with their providers anywhere and anytime from our outstanding mobile app.",
      userImage: ImageUserJohn,
      userImageAlt: "John Paul ",
      userImageTitle: "John Paul ",
      authorName: "John Paul ",
      authorOccupation: "Founder, Physio Outcomes",
      logo: IconPhysioOutcome,
      logowidth: "126",
      logoAlt: "Physio Outcomes",
      logoTitle: "Physio Outcomes"
    }, {
      content: "Staying lean, failing fast, and learning quickly were important for our startup, and Rapidops team is the best at it.",
      userImage: ImageUserJustin,
      userImageAlt: "Justin Cunningham",
      userImageTitle: "Justin Cunningham",
      authorName: "Justin Cunningham",
      authorOccupation: "Founder - YoDish",
      logo: IconYodish,
      logowidth: "100",
      logoAlt: "YoDish",
      logoTitle: "YoDish"
    }, {
      content: "Rapidops team's unique ability to understand the users and design beautiful user experiences has won Salesmate 5-star ratings and multiple industry awards for user experience.",
      userImage: ImageUserSmair,
      userImageAlt: "Samir",
      userImageTitle: "Samir",
      authorName: "Samir",
      authorOccupation: "Co-founder, Salesmate.io",
      logo: IconSalesmate,
      logowidth: "54",
      logoAlt: "Salesmate",
      logoTitle: "Salesmate"
    }
  ]
};

export const succesStoriesObj = {
  classesForFullColumn: "cs-kroger",
  imageForFullColumn: ImageKroger,
  imageAltForFullColumn: "online voice shopping experience",
  imageTitleForFullColumn: "Voice Shopping Platform",
  categoryForFullColumn: "RETAIL",
  headerForFullColumn: "Grocery shopping with your voice-assistant ",
  subHeaderForFullColumn: (<>How we helped a US retail giant deliver hands-free shopping experiences? </>),
  linkForFullColumn:'/work/kroger-grocery-shopping-voice-assistant/',
  
  classesForhalfColumn1: "cs-cb-hlaf",
  imageForHalfColumn1: ImageCBHalf,
  imageAltForHalfColumn1: "digital transformation in manufacturing",
  imageTitleForHalfColumn1: "digital transformation in manufacturing",
  categoryForHalfColumn1: "MANUFACTURING",
  headerForHalfColumn1: "Enabling digital evolution in manufacturing",
  linkForForHalfColumn1: '/work/digital-transformation-manufacturing/',

  classesForhalfColumn2: "cs-pod-hlaf",
  imageForHalfColumn2: ImagePODHalf,
  imageAltForHalfColumn2: "last-mile-automation",
  imageTitleForHalfColumn2: "last-mile-automation",
  categoryForHalfColumn2: "LOGISTICS",
  headerForHalfColumn2: "Reinventing last mile delivery",
  linkForForHalfColumn2: '/work/last-mile-automation/',
};

export const ctaObj = {
  title: <>Let’s discuss your mobile opportunity.</>,
  subtitle: "Unlock your digital transformation opportunities now!",
};